var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._t(
        "default",
        [
          _c("div", { staticClass: "product-detail container page-content" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-12 d-md-none bg-white" }, [
                _c("ul", { staticClass: "breadcrumb" }, [
                  _c("li", { staticClass: "breadcrumb-item" }),
                  _c("li", { staticClass: "breadcrumb-item active" }, [
                    _c("span", [_vm._v(_vm._s(_vm.parentCat))])
                  ])
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "col-12 col-md-5 col-lg-6 product-detail__carousel"
                },
                [_vm._t("image-carousel")],
                2
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "col-12 col-md-7 col-lg-6 product-detail__product-data"
                },
                [
                  _c(
                    "div",
                    [
                      _c("h1", { staticClass: "product-detail__title" }, [
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm._f("itemName")(_vm.currentVariation)) +
                            "\n                        "
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "row mt-2" }, [
                        _c(
                          "div",
                          { staticClass: "col-7" },
                          [
                            _c("item-availability", {
                              staticClass: "product-detail__availability"
                            }),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass: "text-muted small",
                                attrs: { href: "/shop/versandkosten/" }
                              },
                              [
                                _vm._v(
                                  "\n                                    (Ausland abweichend)\n                                "
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-5" }, [
                          _c("span", { staticClass: "product-detail__id" }, [
                            _c("b", [
                              _vm._v(
                                _vm._s(
                                  _vm.$translate(
                                    "Ceres::Template.singleItemNumber"
                                  )
                                ) + ":"
                              )
                            ]),
                            _vm._v(
                              "\n                                    " +
                                _vm._s(_vm.currentVariation.item.id) +
                                "\n                                "
                            )
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _vm._t("tag-list"),
                      _vm._v(" "),
                      _c("hr"),
                      _vm._v(" "),
                      _vm._t("before-price"),
                      _vm._v(" "),
                      _vm.currentVariation.filter.isSalable &&
                      _vm.variationGroupedProperties.length
                        ? _c(
                            "div",
                            { staticClass: "product-detail__property-list" },
                            [_c("order-property-list")],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("item-price", {
                        attrs: {
                          "show-net-prices": _vm.showNetPrices,
                          "has-shipping-costs-category-id":
                            _vm.hasShippingCostsCategoryId,
                          "show-cross-price": _vm.isRecommendedPriceActive
                        }
                      }),
                      _vm._v(" "),
                      _vm._t("after-price"),
                      _vm._v(" "),
                      _vm._t("additional-content-after-vat"),
                      _vm._v(" "),
                      _vm.attributes.length || Object.keys(_vm.units).length
                        ? _c(
                            "div",
                            { staticClass: "product-detail__variation" },
                            [_c("variation-select")],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isShortDescriptionActive &&
                      _vm.currentVariation.texts.shortDescription !== ""
                        ? _c("p", {
                            staticClass: "product-detail__short-description",
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.currentVariation.texts.shortDescription
                              )
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "product-detail__bundle" },
                        [
                          _vm.currentVariation.variation.bundleType === "bundle"
                            ? _c("item-bundle", {
                                attrs: {
                                  "bundle-type":
                                    _vm.currentVariation.variation.bundleType,
                                  "bundle-components":
                                    _vm.currentVariation.bundleComponents
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm._t("before-add-to-basket"),
                      _vm._v(" "),
                      _vm.currentVariation.item.itemType === "set"
                        ? _c("div", { staticClass: "alert alert-info w-100" }, [
                            _vm._v(
                              "\n                            " +
                                _vm._s(
                                  _vm.$translate(
                                    "Ceres::Template.singleItemSetInfo"
                                  )
                                ) +
                                "\n                        "
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("hr"),
                      _vm._v(" "),
                      _vm.currentVariation.item.itemType != "set"
                        ? _c(
                            "div",
                            { staticClass: "product-detail__add-to-basket" },
                            [
                              _c("add-to-basket", {
                                staticClass: "product-detail__qty-basket",
                                attrs: {
                                  "variation-id":
                                    _vm.currentVariation.variation.id,
                                  "is-salable":
                                    !!_vm.currentVariation.filter &&
                                    _vm.currentVariation.filter.isSalable,
                                  "has-children":
                                    !!_vm.currentVariation.filter &&
                                    _vm.currentVariation.filter
                                      .hasActiveChildren,
                                  "interval-quantity":
                                    _vm.currentVariation.variation
                                      .intervalOrderQuantity || 1,
                                  "minimum-quantity":
                                    _vm.currentVariation.variation
                                      .minimumOrderQuantity,
                                  "maximum-quantity":
                                    !!_vm.currentVariation.variation
                                      .maximumOrderQuantity &&
                                    _vm.currentVariation.variation
                                      .maximumOrderQuantity > 0
                                      ? _vm.currentVariation.variation
                                          .maximumOrderQuantity
                                      : null,
                                  "order-properties": _vm.currentVariation.properties.filter(
                                    function(prop) {
                                      return prop.property.isOderProperty
                                    }
                                  ),
                                  "use-large-scale": false,
                                  "show-quantity": true,
                                  "item-url": _vm._f("itemURL")(
                                    _vm.currentVariation
                                  ),
                                  "is-variation-selected":
                                    _vm.isVariationSelected &&
                                    _vm.currentVariation.filter.isSalable,
                                  "has-price": _vm._f("hasItemDefaultPrice")(
                                    _vm.currentVariation
                                  )
                                }
                              }),
                              _vm._v(" "),
                              _vm.isWishListEnabled
                                ? _c(
                                    "div",
                                    { staticClass: "product-detail__wishlist" },
                                    [
                                      _c("add-to-wish-list", {
                                        attrs: {
                                          "variation-id":
                                            _vm.currentVariation.variation.id
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "ul",
                        { staticClass: "social-media share-icons list-inline" },
                        [
                          _c("li", [_vm._v("Teilen:")]),
                          _vm._v(" "),
                          _c("li", { staticClass: "single__social-item" }, [
                            _c(
                              "a",
                              {
                                attrs: {
                                  href:
                                    "http://www.facebook.com/sharer/sharer.php?u=https://www.tuning-fanatics.de/ersatzteile/beleuchtung-birne-lampe/lampen-und-leds/1-x-xenon-super-white-halogen-birne-lampe-6000k-hb4-e-pruefzeichen-tuev-frei/a-39423831/",
                                  "data-toggle": "tooltip",
                                  target: "_blank",
                                  "data-placement": "bottom",
                                  title: "",
                                  "data-original-title":
                                    "Wenn Du den Button anklickst öffnet sich ein neues Fenster, in dem Du dich mit deinen Daten bei Facebook einloggen kannst. Erst nach diesem aktiven Login wird eine direkte Verbindung zu Facebook hergestellt."
                                }
                              },
                              [
                                _c(
                                  "svg",
                                  {
                                    attrs: {
                                      width: "16px",
                                      height: "17px",
                                      viewBox: "0 0 16 17",
                                      version: "1.1",
                                      xmlns: "http://www.w3.org/2000/svg",
                                      "xmlns:xlink":
                                        "http://www.w3.org/1999/xlink"
                                    }
                                  },
                                  [
                                    _c(
                                      "g",
                                      {
                                        attrs: {
                                          id: "Screendesign",
                                          stroke: "none",
                                          "stroke-width": "1",
                                          fill: "none",
                                          "fill-rule": "evenodd"
                                        }
                                      },
                                      [
                                        _c(
                                          "g",
                                          {
                                            attrs: {
                                              id: "xl-redesign-product-v2",
                                              transform:
                                                "translate(-991.000000, -746.000000)",
                                              fill: "#1A1A1D"
                                            }
                                          },
                                          [
                                            _c(
                                              "g",
                                              {
                                                attrs: {
                                                  id: "article",
                                                  transform:
                                                    "translate(351.000000, 246.000000)"
                                                }
                                              },
                                              [
                                                _c(
                                                  "g",
                                                  {
                                                    attrs: {
                                                      id: "art-data",
                                                      transform:
                                                        "translate(552.000000, 0.000000)"
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "g",
                                                      {
                                                        attrs: {
                                                          id: "Share",
                                                          transform:
                                                            "translate(2.496424, 496.194883)"
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "g",
                                                          {
                                                            attrs: {
                                                              id: "facebook",
                                                              transform:
                                                                "translate(86.000000, 0.000000)"
                                                            }
                                                          },
                                                          [
                                                            _c("path", {
                                                              attrs: {
                                                                d:
                                                                  "M15.3307282,17.1390369 L15.3307282,7.60249329 C15.3307282,6.02300325 14.0492551,4.7415302 12.4697651,4.7415302 L2.93322148,4.7415302 C1.35373144,4.7415302 0.0722583927,6.02300325 0.0722583927,7.60249329 L0.0722583927,17.1390369 C0.0722583927,18.718527 1.35373144,20 2.93322148,20 L8.33726287,20 L8.33726287,13.960189 L6.11206936,13.960189 L6.11206936,11.7349955 L8.33726287,11.7349955 L8.33726287,10.0859682 C8.33726287,8.11905607 9.55913252,7.04619491 11.3174328,7.04619491 C12.1518803,7.04619491 12.7876499,7.10579831 13.1055347,7.1356 L13.1055347,9.19191722 L11.7942599,9.20185112 C10.8406056,9.20185112 10.5624564,9.64887661 10.5624564,10.3144479 L10.5624564,11.7349955 L12.877055,11.7349955 L12.579038,13.960189 L10.5624564,13.960189 L10.5624564,20 L12.4697651,20 C14.0492551,20 15.3307282,18.718527 15.3307282,17.1390369 Z",
                                                                id: "fb-icon"
                                                              }
                                                            })
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("span", [_vm._v("Facebook")])
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c("li", { staticClass: "single__social-item" }, [
                            _c(
                              "a",
                              {
                                attrs: {
                                  href:
                                    "https://twitter.com/intent/tweet?text=1x XENON SUPER WHITE HALOGEN BIRNE LAMPE 6000K HB4 E-PRÜFZEICHEN Eintragungsfrei&url=https://www.tuning-fanatics.de/ersatzteile/beleuchtung-birne-lampe/lampen-und-leds/1-x-xenon-super-white-halogen-birne-lampe-6000k-hb4-e-pruefzeichen-tuev-frei/a-39423831/&via=TWITTER-HANDLE",
                                  target: "_blank",
                                  "data-toggle": "tooltip",
                                  "data-placement": "bottom",
                                  title: "",
                                  "data-original-title":
                                    "Wenn Du den Button anklickst öffnet sich ein neues Fenster, in dem Du dich mit deinen Daten bei Twitter einloggen kannst. Erst nach diesem aktiven Login wird eine direkte Verbindung zu Twitter hergestellt."
                                }
                              },
                              [
                                _c(
                                  "svg",
                                  {
                                    attrs: {
                                      width: "16px",
                                      height: "17px",
                                      viewBox: "0 0 16 17",
                                      version: "1.1",
                                      xmlns: "http://www.w3.org/2000/svg",
                                      "xmlns:xlink":
                                        "http://www.w3.org/1999/xlink"
                                    }
                                  },
                                  [
                                    _c(
                                      "g",
                                      {
                                        attrs: {
                                          id: "Screendesign",
                                          stroke: "none",
                                          "stroke-width": "1",
                                          fill: "none",
                                          "fill-rule": "evenodd"
                                        }
                                      },
                                      [
                                        _c(
                                          "g",
                                          {
                                            attrs: {
                                              id: "xl-redesign-product-v2",
                                              transform:
                                                "translate(-1201.000000, -746.000000)",
                                              fill: "#1A1A1D"
                                            }
                                          },
                                          [
                                            _c(
                                              "g",
                                              {
                                                attrs: {
                                                  id: "article",
                                                  transform:
                                                    "translate(351.000000, 246.000000)"
                                                }
                                              },
                                              [
                                                _c(
                                                  "g",
                                                  {
                                                    attrs: {
                                                      id: "art-data",
                                                      transform:
                                                        "translate(552.000000, 0.000000)"
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "g",
                                                      {
                                                        attrs: {
                                                          id: "Share",
                                                          transform:
                                                            "translate(2.496424, 496.194883)"
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "g",
                                                          {
                                                            attrs: {
                                                              id: "twitter",
                                                              transform:
                                                                "translate(295.688182, 0.000000)"
                                                            }
                                                          },
                                                          [
                                                            _c("path", {
                                                              attrs: {
                                                                d:
                                                                  "M13.2441036,9.35492904 C12.8721812,9.52096583 12.4703782,9.63386916 12.0386826,9.6936424 C12.4903026,9.42798354 12.7991264,9.03946327 12.9651632,8.52806995 C12.5334676,8.78044587 12.0884956,8.94980086 11.6302341,9.03613999 C11.2251043,8.59780286 10.7170394,8.37863758 10.106024,8.37863758 C9.52821593,8.37863758 9.03509406,8.58285978 8.62664355,8.99131028 C8.21819304,9.39976079 8.01397085,9.89288267 8.01397085,10.4706907 C8.01397085,10.6632934 8.03057428,10.8226863 8.06378163,10.9488743 C7.20703179,10.902384 6.40342577,10.6865394 5.65293947,10.301334 C4.90245317,9.91612867 4.26488145,9.40142233 3.74020518,8.75719958 C3.54760251,9.08927316 3.45130261,9.44126588 3.45130261,9.8131883 C3.45130261,10.5703161 3.75348504,11.1514361 4.35785896,11.5565659 C4.04570979,11.5499244 3.71364119,11.4635866 3.36164319,11.2975498 L3.36164319,11.3174741 C3.36164319,11.8155845 3.52767749,12.2588961 3.85975108,12.6474222 C4.19182466,13.0359483 4.60026904,13.276698 5.08509648,13.3696786 C4.8924938,13.4228104 4.72313881,13.4493759 4.57702643,13.4493759 C4.4906873,13.4493759 4.36118055,13.4360931 4.18850228,13.4095272 C4.32797319,13.8279399 4.5753643,14.1732913 4.93068303,14.4455916 C5.28600177,14.717892 5.68946512,14.8573608 6.14108519,14.8640023 C5.37067448,15.4617347 4.50397542,15.7605965 3.54096203,15.7605965 C3.36828377,15.7605965 3.20224946,15.7506344 3.04285414,15.73071 C4.02579195,16.3550083 5.09505286,16.6671528 6.25066893,16.6671528 C6.99451376,16.6671528 7.69185783,16.5492685 8.34272205,16.3134962 C8.99358628,16.077724 9.55146153,15.7622588 10.0163645,15.3670912 C10.4812676,14.9719237 10.8814102,14.5169897 11.2168046,14.0022756 C11.5521989,13.4875616 11.8012503,12.9496104 11.9639664,12.3884061 C12.1266824,11.8272017 12.2080392,11.2676661 12.2080392,10.7097825 C12.2080392,10.590236 12.2047186,10.5005775 12.1980771,10.4408042 C12.6164898,10.141938 12.9651618,9.77998323 13.2441036,9.35492904 Z M15.794416,7.42227044 L15.794416,16.9859419 C15.794416,17.776277 15.5138181,18.4520366 14.9526137,19.013241 C14.3914093,19.5744453 13.7156497,19.8550433 12.9253146,19.8550433 L3.36164319,19.8550433 C2.57130806,19.8550433 1.89554845,19.5744453 1.33434409,19.013241 C0.773139737,18.4520366 0.492541767,17.776277 0.492541767,16.9859419 L0.492541767,7.42227044 C0.492541767,6.63193531 0.773139737,5.9561757 1.33434409,5.39497135 C1.89554845,4.83376699 2.57130806,4.55316902 3.36164319,4.55316902 L12.9253146,4.55316902 C13.7156497,4.55316902 14.3914093,4.83376699 14.9526137,5.39497135 C15.5138181,5.9561757 15.794416,6.63193531 15.794416,7.42227044 Z",
                                                                id:
                                                                  "twitter-icon"
                                                              }
                                                            })
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("span", [_vm._v("Twitter")])
                              ]
                            )
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _vm._t("after-add-to-basket"),
                      _vm._v(" "),
                      _vm._t("additional-content-after-add-to-basket")
                    ],
                    2
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-12 col-lg-10 mx-auto desc-container" },
                [
                  _c("h2", { staticClass: "text-center" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$translate("Ceres::Template.singleItemDescription")
                      )
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "my-4",
                    domProps: {
                      innerHTML: _vm._s(_vm.currentVariation.texts.description)
                    }
                  })
                ]
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "last-seen-container" },
              [
                _vm._t("item-list-container"),
                _vm._v(" "),
                _vm._t("feedback-container")
              ],
              2
            )
          ])
        ],
        {
          getDataField: _vm.getDataField,
          getFilteredDataField: _vm.getFilteredDataField
        }
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }